/**
 * API: Klaviyo
 * -----------------------------------------------------------------------------
 * Provides a wrapper for the Klaviyo API.
 * - https://developers.klaviyo.com/en/reference/api-overview
 *
 * Payload must match the structure outlined in the link below:
 * - https://developers.klaviyo.com/en/reference/create_client_subscription
 */

/**
 * Subscribes a new email address to Klaviyo.
 * - {data} can only include the properties `type` and `attributes`.
 *
 * @param {Object} data - Form data object.
 * @returns {Promise}
 */
export default function subscribe(data = {}) {
  const key = cnvs?.credentials?.klaviyo?.publicKey

  if (!data || !key) {
    return Promise.reject(
      new Error('Email address or Klaviyo credentials not set.'),
    )
  }

  const url = `https://a.klaviyo.com/client/subscriptions/?company_id=${key}`
  const payload = {

    /**
     * Must use JSON.stringify() because of strict Klaviyo requirements.
     */
    body: JSON.stringify({ data }),
    headers: {
      revision: '2022-10-17',
      'content-type': 'application/json',
    },
    method: 'POST',
  }

  return new Promise((resolve, reject) => {
    fetch(
      url,
      payload,
    )

      /**
       * Using response.text() as response.json() resulted in a SyntaxError due
       * to 'Unexpected end of JSON'.
       */
      .then(response => response.text())
      .then(response => resolve(response))
      .catch(
        error => {
          reportError('Klaviyo API request failed', error)
          reject(error)
        },
      )
  })
}
